"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BAR_CHART_AXIS_CONFIG = exports.BASE_CHART_AXIS_CONFIG = exports.DUAL_AXES_SUPPORTED_CHARTS = exports.AXIS_NAME = exports.AXIS = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
exports.AXIS = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    DUAL: "dual",
};
var AXIS_NAME;
(function (AXIS_NAME) {
    AXIS_NAME["X"] = "xaxis";
    AXIS_NAME["Y"] = "yaxis";
    AXIS_NAME["SECONDARY_X"] = "secondary_xaxis";
    AXIS_NAME["SECONDARY_Y"] = "secondary_yaxis";
})(AXIS_NAME = exports.AXIS_NAME || (exports.AXIS_NAME = {}));
exports.DUAL_AXES_SUPPORTED_CHARTS = [
    sdk_ui_1.VisualizationTypes.COLUMN,
    sdk_ui_1.VisualizationTypes.BAR,
    sdk_ui_1.VisualizationTypes.LINE,
    sdk_ui_1.VisualizationTypes.COMBO,
];
var BASE_X_AXIS = {
    name: AXIS_NAME.X,
    title: "properties.xaxis.title",
    subtitle: "",
    primary: false,
};
var BASE_Y_AXIS = {
    name: AXIS_NAME.Y,
    title: "properties.yaxis.title",
    subtitle: "",
    primary: true,
};
var BASE_SECONDARY_Y_AXIS = tslib_1.__assign(tslib_1.__assign({}, BASE_Y_AXIS), { name: AXIS_NAME.SECONDARY_Y });
var BAR_X_AXIS = tslib_1.__assign(tslib_1.__assign({}, BASE_X_AXIS), { primary: true });
var BAR_SECONDARY_X_AXIS = tslib_1.__assign(tslib_1.__assign({}, BASE_X_AXIS), { name: AXIS_NAME.SECONDARY_X, primary: true });
var BAR_Y_AXIS = tslib_1.__assign(tslib_1.__assign({}, BASE_Y_AXIS), { primary: false });
exports.BASE_CHART_AXIS_CONFIG = (_a = {},
    _a[exports.AXIS.PRIMARY] = [BASE_X_AXIS, BASE_Y_AXIS],
    _a[exports.AXIS.SECONDARY] = [BASE_X_AXIS, BASE_SECONDARY_Y_AXIS],
    _a[exports.AXIS.DUAL] = [
        BASE_X_AXIS,
        tslib_1.__assign(tslib_1.__assign({}, BASE_Y_AXIS), { subtitle: "properties.axis.left" }),
        tslib_1.__assign(tslib_1.__assign({}, BASE_SECONDARY_Y_AXIS), { subtitle: "properties.axis.right" }),
    ],
    _a);
exports.BAR_CHART_AXIS_CONFIG = (_b = {},
    _b[exports.AXIS.PRIMARY] = [BAR_X_AXIS, BAR_Y_AXIS],
    _b[exports.AXIS.SECONDARY] = [BAR_SECONDARY_X_AXIS, BAR_Y_AXIS],
    _b[exports.AXIS.DUAL] = [
        tslib_1.__assign(tslib_1.__assign({}, BAR_SECONDARY_X_AXIS), { subtitle: "properties.axis.top" }),
        tslib_1.__assign(tslib_1.__assign({}, BAR_X_AXIS), { subtitle: "properties.axis.bottom" }),
        BAR_Y_AXIS,
    ],
    _b);
//# sourceMappingURL=axis.js.map